import { render, staticRenderFns } from "./tircarnet.vue?vue&type=template&id=96007f26&"
import script from "./tircarnet.vue?vue&type=script&lang=js&"
export * from "./tircarnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports